import { render, staticRenderFns } from "./editor-text-styles.vue?vue&type=template&id=3d2a3ed7"
import script from "./editor-text-styles.vue?vue&type=script&lang=js"
export * from "./editor-text-styles.vue?vue&type=script&lang=js"
import style0 from "./editor-text-styles.vue?vue&type=style&index=0&id=3d2a3ed7&prod&lang=less"
import style1 from "./editor-text-styles.vue?vue&type=style&index=1&id=3d2a3ed7&prod&lang=less"
import style2 from "./editor-text-styles.vue?vue&type=style&index=2&id=3d2a3ed7&prod&lang=less"
import style3 from "./editor-text-styles.vue?vue&type=style&index=3&id=3d2a3ed7&prod&lang=less"
import style4 from "./editor-text-styles.vue?vue&type=style&index=4&id=3d2a3ed7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports